import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";

// Globally register vee-validate components
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// Custom Rule Messages
const messages = {
  alpha: "The field may only contain alphabetic characters",
  alpha_num: "The field may only contain alpha-numeric characters",
  alpha_dash:
    "The field may contain alpha-numeric characters as well as dashes and underscores",
  alpha_spaces:
    "The field may only contain alphabetic characters as well as spaces",
  between: "The field must be between {min} and {max}",
  confirmed: "The field confirmation does not match",
  digits: "The field must be numeric and exactly contain {length} digits",
  dimensions: "The field must be {width} pixels by {height} pixels",
  email: "The field must be a valid email",
  excluded: "The field is not a valid value",
  ext: "The field is not a valid file",
  image: "The field must be an image",
  integer: "The field must be an integer",
  length: "The field must be {length} long",
  max_value: "The field must be {max} or less",
  max: "The field may not be greater than {length} characters",
  mimes: "The field must have a valid file type",
  min_value: "The field must be {min} or more",
  min: "The field must be at least {length} characters",
  numeric: "The field may only contain numeric characters",
  oneOf: "The field is not a valid value",
  regex: "The field format is invalid",
  required_if: "The field is required",
  required: "The field is required",
  size: "The field size must be less than {size}KB",
  double: "The field must be a valid decimal"
};

// Set rules
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

// Ad-hoc rules
extend("notTaken", {
  message: "Already taken.",
  validate(value, args) {
    return !args.some(x => value === x);
  }
});

extend('noPeriods', {
  validate: (value) => !/\./.test(value),
  message: 'Periods are not allowed.',
});

extend("uniqueChar", val => {
  var obj = {};
  for (var z = 0; z < val.length; ++z) {
    var ch = val[z];
    if (obj[ch]) return `Characters cannot be used twice. '${ch}' is already used.`;
    obj[ch] = true;
  }
  return true;
});
